/**
 * 認証確認リクエスト
 */
export class AuthConfirmRequest {
	public authMailId: string = null; // 認証メールID
}